/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'

let url_ = '' // 测试

const prodOriginArr = ['https://flywheel.ledu19.cn', 'https://fd.ledu19.cn'];
const previewOriginArr = ['https://fd-preview.ledu19.cn'];

if(previewOriginArr.includes(document.location.origin)){
	url_ = 'https://admin-wx-preview.ledu19.cn/'
}
else if(prodOriginArr.includes(document.location.origin)){ // 线上环境
	url_ = 'https://admin-wx.ledu19.cn/'
}
else { // 测试环境
	url_ = 'https://wx-admin.test.gzlize.com/'
}

// 环境的切换  //打包线上时用
axios.defaults.baseURL = url_
// 导出excel表格用的地址
axios.excel_url = url_ 

// 页面内的几个按钮跳转的地址。比如/accountBD页的 授权推广账户 按钮
axios.open_url = "https://feidie.ledu19.cn/"

// 带上cookie
axios.defaults.withCredentials = true
//反向代理
// axios.defaults.baseURL = '/api/'

// 请求超时时间
// axios.defaults.timeout = 10000

// post请求头
axios.defaults.headers.post['Content-Type'] = '	application/x-www-form-urlencoded'

// axios.defaults.headers.common['cookie'] = 'test_server_session=eyJpdiI6IjNVUG4zdVVVcUF4cnlhMjdNeUh6NWc9PSIsInZhbHVlIjoiZWpPcXlENnpMVHA1SjgyTTZna3ZSMGlibnYwaTFOeUZ5MVdZaC9pczFKYWNWS29XVEVpZDRNS1ZNQzduZnhNVlY4dXd3dEtWUXVGUmx4eVJzZkFnR1EwVXNWTWVaOG0yNjd4dE5YNUhJMWpJeCt1RUp4UE9YNlRPYWJOV3piV1QiLCJtYWMiOiIwNTZkNGMxNzIwZjA0MWU4MTNhNjU2MDQxODU5MmViZjFjODkwYjRhNjhmYTE4NTJlOWNlY2JiMjE3MzMwMmNmIiwidGFnIjoiIn0%3D'

// 请求拦截器
axios.interceptors.request.use(
  config => {
	config.headers["Authorization"] = 'Bearer ' + localStorage.getItem("access_token")
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
// axios.interceptors.response.use(
//   response => {
//     if (response.status === 200) {
//       return Promise.resolve(response)
//     } else {
//       return Promise.reject(response)
//     }
//   },
//   // 服务器状态码不是200的情况
//   error => {
//     console.log(error.response)
//     if (error.response.status) {
//       switch (error.response.status) {
//         // 404请求不存在
//         case 404:
//           console.log('网络请求不存在')
//           break
//         // 其他错误，直接抛出错误提示
//         default:
//           console.log('其他错误')
//       }
//       return Promise.reject(error.response)
//     }
//   }
// )
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        reject(error)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        reject(error)
      })
  })
}
